/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycApprovalDecisionRequestDto } from '../../models/kyc-approval-decision-request-dto';
import { KycProcessApprovalDto } from '../../models/kyc-process-approval-dto';

export interface Decide$Params {
  processId: string;
      body: KycApprovalDecisionRequestDto
}

export function decide(http: HttpClient, rootUrl: string, params: Decide$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessApprovalDto>> {
  const rb = new RequestBuilder(rootUrl, decide.PATH, 'post');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessApprovalDto>;
    })
  );
}

decide.PATH = '/kyc/processes/{processId}/approvals';
